import React, { Component } from 'react'
import app from '../../../feathers'
import { injectState, provideState } from 'freactal'
import { Spinner, Tooltip, Icon } from 'react-mdl'
import Button from '../../../components/Button'
import contentDisposition from 'content-disposition'
import axios from 'axios'
import Table from '../../../components/Table'
import DisplayError from '../../../components/DisplayError'
import styled from 'styled-components'

import DocumentOptions from './DocumentOptions'

const {
  NODE_ENV,
  API_URI = NODE_ENV === 'production' ? '/' : 'http://localhost:3030/',
} = process.env

const getName = disposition =>
  disposition
    ? contentDisposition.parse(disposition).parameters.filename
    : 'response.docx'

let counter = 0
const withState = provideState({
  initialState: () => ({
    documents: [],
  }),
  effects: {
    setDocument: async (effects, doc) => s => ({
      ...s,
      documents: [doc, ...s.documents.filter(({ id }) => id !== doc.id)],
    }),
    generateDocument: async ({ setDocument }, { documentName, unitId, multiChoice }) => {
      const id = counter++
      await setDocument({ id, documentName, generating: true })
      const url = `${API_URI}documents/${documentName}/${unitId}?multiChoice=${multiChoice}`
      const token = await app.passport.getJWT()
      try {
        const response = await axios({
          url,
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob',
          onDownloadProgress: ({ loaded, target }) => {
            let disposition
            try {
              disposition = target.getResponseHeader('content-disposition')
            } catch (e) {
              disposition = ''
            }
            setDocument({
              id,
              filename: getName(disposition),
              documentName,
              progress: loaded,
            })
          },
        })
        if (response.status !== 200) {
          throw new Error(response.statusText || 'Error.')
        }
        const disposition = response.headers['content-disposition']
        const href = window.URL.createObjectURL(response.data)
        await setDocument({
          id,
          filename: getName(disposition),
          documentName,
          href,
          warning: response.headers['x-postprocessor-failed']
            ? 'Postprocessor failed.'
            : null,
        })
      } catch (error) {
        const errorMessage = await new Promise((resolve, reject) => {
          if (error.response.data) {
            var reader = new FileReader()
            reader.onload = () => {
              resolve(reader.result)
            }
            reader.onerror = err => {
              reject(err)
            }
            reader.readAsText(error.response.data)
          } else {
            resolve()
          }
        })
        await setDocument({
          id,
          documentName,
          loading: false,
          error,
          errorMessage,
        })
      }
    },
  },
})

class GenerateDocuments extends Component {
  componentWillUnmount() {
    const { state: { documents } } = this.props
    Object.values(documents).map(
      ({ href }) => href && window.URL.revokeObjectURL(href),
    )
  }
  handleGenerateDocument = (unitId, documentName, multiChoice) => {
    this.props.effects.generateDocument({ documentName, unitId, multiChoice });
  }
  render() {
    const {
      state: { unit, documents },
      effects: { snackbarAlert },
    } = this.props
    const { _id: unitId, code, title, industry, sections } = unit
    const docs = Object.values(documents)
    return (
      <div>
        <h3>
          Generate Documents<br />
          <small>
            {code} | {title} | {industry}
          </small>
        </h3>
        <div>
          <DocumentOptions unit={unit} multiChoice={false} snackbarAlert={snackbarAlert} onGenerateDocument={this.handleGenerateDocument} ></DocumentOptions>
          <DocumentOptions unit={unit} multiChoice={true} snackbarAlert={snackbarAlert} onGenerateDocument={this.handleGenerateDocument} ></DocumentOptions>
        </div>
        {docs.length > 0 && (
          <div>
            <h3>Progress</h3>
            <Table>
              <thead>
                <tr>
                  <th>Document</th>
                  <th>Progress</th>
                </tr>
              </thead>
              <tbody>
                {docs.map(
                  (
                    {
                      documentName,
                      progress, // generating,
                      href,
                      filename,
                      error,
                      errorMessage,
                      warning,
                    },
                    i,
                  ) => (
                    <tr key={i}>
                      <td>{filename || documentName}</td>
                      <td>
                        {error ? (
                          <DisplayError
                            msg={errorMessage}
                            error={error}
                            errorContext={{ documentName }}
                          />
                        ) : href ? (
                          <Button href={href} download={filename} primary>
                            Link to Document
                            {warning && (
                              <Tooltip label={warning}>
                                <Icon
                                  name="warning"
                                  style={{ color: 'orange' }}
                                />
                              </Tooltip>
                            )}
                          </Button>
                        ) : progress ? (
                          `${(progress / (1024 * 1024)).toFixed(2)}mB`
                        ) : (
                          <Spinner />
                        )}
                      </td>
                    </tr>
                  ),
                )}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    )
  }
}

export default withState(injectState(GenerateDocuments))



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/GenerateDocuments/index.js